'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('settings-list', {
      url: '/admin/settings/list',
      template: '<settings-list></settings-list>',
        authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/settings/list/settings-list.routes.js